import { Component } from '@angular/core';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { DatePipe, NgFor, NgIf } from '@angular/common';
import { DatasearchService } from '../../_services/datasearch.service';
import { ActivatedRoute, RouterLink } from '@angular/router';
// import { BusyService } from '../../_services/busy.service';

@Component({
  selector: 'app-press-release-details',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, NgFor, RouterLink, NgIf, DatePipe],
  templateUrl: './press-release-details.component.html',
  styleUrl: './press-release-details.component.scss'
})
export class PressReleaseDetailsComponent {
  transparent = false;
  pressReleaseList: any = [];
  getDetails: any = [];
  pressReleaseDetails: any = [];
  // logoBaseUrl = 'https://www.chemrobotics.com/agropat/uploads/press_release/';
  press_release_image_url = '';
  slug: any;
  currentUrl: string;

  constructor(private datasearch_service: DatasearchService, private route: ActivatedRoute,) {
    this.currentUrl = window.location.href; // Get the current URL
    this.press_release_image_url = this.datasearch_service.ApiUrl + '/uploads/press-release-images/';
  }

  ngOnInit() {
    const route: any = this.route?.snapshot?.params
    this.slug = route?.id
    if (this.slug) {
      this.getpressDetail();
    }
    this.getPressRelease();
  }
  getpressDetail() {
    this.datasearch_service.getPressReleasesDetails(this.slug).subscribe((res) => {
      this.getDetails = res.data;
      // console.log(this.press_release_image_url+this.getDetails.logo)
    },
      (error) => {
        // console.log(error);
      });

  }

  getPressReleaseImageUrl(data: any): string {
    if (!data) return '';
    const filename = data.press_release_image || data.logo || data.image;
    if (!filename) return '';
    if (filename.toString().startsWith('http')) return filename;
    return this.press_release_image_url + filename;
  }

  getPressRelease() {
    this.datasearch_service.getPressReleases().subscribe((res) => {
      this.pressReleaseList = res.data;
    },
      (error) => {
        // console.log(error);
      });
  }
  showFullContent(data: any) {

    this.getDetails = data;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  openLink(url: string) {
    if (url) {
      window.open(url, '_blank');
    }
  }
  shareViaEmail() {
    const subject = 'Check out this page!';
    const body = `Here is the link: ${this.currentUrl}`;
    const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink; // Open the email client
  }

  shareViaSMS() {
    const smsLink = `sms:?body=${encodeURIComponent(this.currentUrl)}`;
    window.location.href = smsLink; // Open SMS app
  }

  shareViaWhatsApp() {
    const text = `Check this out! ${this.currentUrl}`;
    const whatsappLink = `https://wa.me/?text=${encodeURIComponent(text)}`;

    window.open(whatsappLink, '_blank'); // Open WhatsApp share dialog
  }

  shareViaMessenger() {
    const messengerLink = `https://www.messenger.com/share/?link=${encodeURIComponent(this.currentUrl)}`;
    window.open(messengerLink, '_blank'); // Open Messenger share dialog
  }

  shareViaViber() {
    const viberLink = `viber://forward?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(viberLink, '_blank'); // Open Viber share dialog
  }

  shareViaFacebook() {
    const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.currentUrl)}`;

    window.open(facebookLink, '_blank'); // Open Facebook share dialog
  }

  shareViaTwitter() {
    const text = `Check this out! ${this.currentUrl}`;
    const twitterLink = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;

    window.open(twitterLink, '_blank'); // Open Twitter share dialog
  }

  shareViaLinkedIn() {
    const linkedInLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(linkedInLink, '_blank'); // Open LinkedIn share dialog
  }

  shareViaPinterest() {
    const pinterestLink = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(pinterestLink, '_blank'); // Open Pinterest share dialog
  }

  shareViaReddit() {
    const redditLink = `https://www.reddit.com/submit?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(redditLink, '_blank'); // Open Reddit share dialog
  }

  shareViaTumblr() {
    const tumblrLink = `https://www.tumblr.com/share/link?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(tumblrLink, '_blank'); // Open Tumblr share dialog
  }

  shareViaTelegram() {
    const telegramLink = `https://t.me/share/url?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(telegramLink, '_blank'); // Open Telegram share dialog
  }

  shareViaVK() {
    const vkLink = `https://vk.com/share.php?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(vkLink, '_blank'); // Open VK share dialog
  }

  shareViaMix() {
    const mixLink = `https://mix.com/add?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(mixLink, '_blank'); // Open Mix share dialog
  }

  shareViaXing() {
    const xingLink = `https://www.xing.com/app/user?op=share;url=${encodeURIComponent(this.currentUrl)}`;
    window.open(xingLink, '_blank'); // Open Xing share dialog
  }

  shareViaLine() {
    const lineLink = `https://line.me/R/share?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(lineLink, '_blank'); // Open Line share dialog
  }

  copyLink() {
    navigator.clipboard.writeText(this.currentUrl).then(() => {
      alert('Link copied to clipboard!');
    });
  }
}


